import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { AkumaPrimeSchema, AgtAkumaPrimeKwVM, AkumaPrimeType } from 'app/stores/ui/agt.akumaprime.ui.store';
import { AkumaPrimeHorizontalBarChart } from './AkumaPrimeBarChart';
import { useEffect, useState } from 'react';
import { runInAction } from 'mobx';
import { CheckboxControl } from 'app/components/common/CheckboxControl';
import { AkumaPrimeSankeyChart } from './AkumaPrimeSankeyChart';
import { AkumaPrimeOptions } from './AkumaPrimeOptions';


export const AkumaPrimeBnrOverview = observer(() => {
	const { agtAkumaPrimeUiStore, bnrAkumaPrimeUiStore, agenturListUiStore } = useStore();
	const [data, setData] = useState<AgtAkumaPrimeKwVM[]>([]);

	useEffect(() => {
		agtAkumaPrimeUiStore.aggreagateAgtsByKw(agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent).then((res) => {
			let items = agenturListUiStore.applyFilterOnAgt(res) as AgtAkumaPrimeKwVM[];
			runInAction(() => {
				bnrAkumaPrimeUiStore.items = items;
				bnrAkumaPrimeUiStore.calc();
			});
			setData(items);
		});
	}, [agtAkumaPrimeUiStore, agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent, agenturListUiStore.filterHasChanged, agenturListUiStore, bnrAkumaPrimeUiStore]);

	return (
		<>
			<AkumaPrimeOptions />
			{data.length === 0 ? (
				<>
					<div className="pad-1rem content">
						<h3 className="title is-5">Keine Daten</h3>
						<p>Keine AKUMA Prime teilnahme.</p>
					</div>
				</>
			) : (
				<div className="table-container">
					<div className="pad-1rem">
						<h2 className="title is-3">Einordnung</h2>
						<AkumaPrimeSankeyChart type={AkumaPrimeType.einordnung} data={data} />
					</div>
					{agtAkumaPrimeUiStore.showGraphs && (
						<div className="pad-1rem border-bottom">
							<AkumaPrimeHorizontalBarChart data={data} primeType={AkumaPrimeType.einordnung} schema={AkumaPrimeSchema.filter((s) => s.type === AkumaPrimeType.einordnung)} />
						</div>
					)}

					<div className="pad-1rem page-break-avoid">
						<h2 className="title is-3">Terminierung</h2>
						<AkumaPrimeSankeyChart type={AkumaPrimeType.terminierung} data={data} />
					</div>
					{agtAkumaPrimeUiStore.showGraphs && (
						<div className="pad-1rem border-bottom">
							<AkumaPrimeHorizontalBarChart data={data} primeType={AkumaPrimeType.terminierung} schema={AkumaPrimeSchema.filter((s) => s.type === AkumaPrimeType.terminierung)} />
						</div>
					)}
				</div>
			)}
		</>
	);
});
